import React from 'react';
import './style.scss';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';

const CardsListCardFooter = ({ heading, icons, className, children, onClick }) => {
  const needHeading = !!heading?.value;
  const needIcons = icons?.length > 0;

  if (!needHeading && !needIcons) return null;

  return (
    <div className={clsx('cl-card-footer', className)} onClick={onClick}>
      {needHeading && (
        <div className="cl-card-footer-text">
          <Text field={heading} />
        </div>
      )}
      {needIcons && (
        <div className="cl-card-footer-icons">
          {icons.map((icon, index) => (
            <Image field={icon.fields.image} className="cl-card-footer-icon" key={index} />
          ))}
        </div>
      )}
      {children}
    </div>
  );
};

export default CardsListCardFooter;
